import request from '@/utils/request'

let WarehouseApi = {

  /*仓库盘点列表*/
  list(data) {
    return request._post('/shop/plus.warehouse.Index/index', data);
},

linelist(data) {
    return request._post('/shop/plus.warehouse.Index/linelist', data);
},

/*添加仓库盘点*/
add(data) {
    return request._post('/shop/plus.warehouse.Index/add', data);
},
/*修改仓库盘点*/
edit(data) {
    return request._post('/shop/plus.warehouse.Index/edit', data);
},
/*删除仓库盘点*/
del(data) {
    return request._post('/shop/plus.warehouse.Index/del', data);
},
/*仓库盘点详情*/
detail(data) {
  return request._post('/shop/plus.warehouse.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.warehouse.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.warehouse.Setting/getSetting', data, errorback);
    },

      /*仓库盘点列表*/
  listKw(data) {
    return request._post('/shop/plus.warehouse_kw.Index/index', data);
},
/*添加仓库盘点*/
addKw(data) {
    return request._post('/shop/plus.warehouse_kw.Index/add', data);
},
/*修改仓库盘点*/
editKw(data) {
    return request._post('/shop/plus.warehouse_kw.Index/edit', data);
},
/*删除仓库盘点*/
delKw(data) {
    return request._post('/shop/plus.warehouse_kw.Index/del', data);
},
/*仓库盘点详情*/
detailKw(data) {
  return request._post('/shop/plus.warehouse_kw.Index/detail', data);
},
}
export default WarehouseApi;



// WEBPACK FOOTER //
// ./src/api/warehouse.js